
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'IntersectElement',
  props: {
    root: Object as PropType<Element | Document | null>,
    target: Object as PropType<Element>,
    options: Object as PropType<{ threshold: number }>,
  },
  data() {
    return {
      observer: undefined,
    }
  },
  mounted(): void {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!!entry && entry.isIntersecting) {
          this.$emit('intersect')
        }
      },
      { root: this.root, ...this.options },
    )
    this.observer.observe(this.target || this.$el)
  },
  destroyed(): void {
    this.observer.disconnect()
  },
})
